import {DeprecatedColorIndicator as ColorIndicator, DeprecatedFlexItem as FlexItem} from '@forecast-it/design-system';
import React from 'react';
import HeaderColumnContainer from './HeaderColumnContainer';
import {useIntl} from 'react-intl';
import ProjectPrefixFlexItem from './ProjectPrefixFlexItem';
import NoShrinkFlexItem from './NoShrinkFlexItem';
import {hasFeatureFlag} from '../../../../forecast-app/shared/util/FeatureUtil';
import {ProjectIndicator} from 'web-components';
import {Link} from 'react-router-dom';

const ProjectHeaderColumn = ({project}) => {
	const {formatMessage} = useIntl();
	const fullAccessToProject = project?.fullAccessToProject;
	const readOnlyAccess = project?.readOnlyAccess;
	const colorIndicator = <ColorIndicator size={'s'} color={project.projectColor} />;
	return (
		<HeaderColumnContainer>
			<NoShrinkFlexItem flexBasis={'28px'}>
				{hasFeatureFlag('resource_program_management_v1') ? (
					readOnlyAccess ? (
						colorIndicator
					) : (
						<Link to={`/project/P-${project.companyProjectId}`}>{colorIndicator}</Link>
					)
				) : (
					<ProjectIndicator
						project={project}
						name={project.name}
						id={project.companyProjectId}
						color={project.projectColor}
						noTitle={!fullAccessToProject}
					/>
				)}
			</NoShrinkFlexItem>
			{hasFeatureFlag('resource_program_management_v1') ? (
				<ProjectPrefixFlexItem>P{project.companyProjectId}</ProjectPrefixFlexItem>
			) : null}
			<FlexItem>
				{fullAccessToProject
					? project.name
					: formatMessage({
							id: 'common.no_project_access',
					  })}
			</FlexItem>
		</HeaderColumnContainer>
	);
};

export default ProjectHeaderColumn;
